<div class="c-row c-row-collapsed">
  <div class="c-col c-p-horizontal-lg">
    <div class="c-alert {{ alert.alertClass }} c-alert-top c-alert-has-icon c-m-bottom-sm">
      <i class="fa fa-exclamation-circle c-alert-icon" aria-hidden="true"></i> 
      <strong>{{ alert.message }}</strong>
    </div>
  </div>
</div>